import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import CreateButton from 'components/button/CreateButton';
import Header from 'components/ui/general/Header';
import Title from 'components/ui/general/Title';
import SubcategoriesList from './SubcategoriesList';
import translate from 'components/hoc/translate';

const SubcategoriesListContainer = (props) => {
    const {
        resource,
        translate,
    } = props;

    return (
        <div>
            <Header>
                <Title title={ translate('resources.subcategories.title') } />

                <Actions>
                    <CreateButton basePath={ resource } />
                </Actions>
            </Header>

            <SubcategoriesList
                { ...props }
            />
        </div>
    );
};

SubcategoriesListContainer.propTypes = {
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(SubcategoriesListContainer);



// WEBPACK FOOTER //
// ./src/pages/subcategories/list/SubcategoriesListContainer.js